import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import $ from 'jquery';
import {appName,copyRight} from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Helmet} from "react-helmet";
import {Nav,Navbar,NavDropdown,Row,Col,Table,Modal,DropdownButton, Dropdown} from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";

import PageTitle from '../../../containers/PageTitle';
import Add from './Add';
import Edit from './Edit';

class TestMaster extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('loginUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage:1,
			dataList: [],
			dataView: [],
			editData: [],
		}
		
		this.handleSearch = this.handleSearch.bind(this);
		this.loadTestMasters = this.loadTestMasters.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}
	
	componentDidMount(){
		
		this.loadTestMasters();
	}
	
	loadTestMasters(){
		this.setState({showLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('testmaster/gettestlist/'+this.state.masterId+'/'+this.state.companyId+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				this.setState({dataList: res['data'].data, dataView: res['data'].data, showLoader:false});	
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false});	
			}
		});
	}
	
	handleSearch(e){
		try{
			
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function(obj){
				const gname = obj.testname.toUpperCase();
				const gcode = obj.testcode.toUpperCase();
				return ((gname.indexOf(v)>-1) || (gcode.indexOf(v)>-1));
			});
			this.setState({dataView:l});
		}
		catch(error){
			console.log(error);
		}
	}
	
	handleEdit(id,e){
		var list = this.state.dataView;
		var index = list.findIndex(function(obj){ return obj.id==id });
		var l = list[index];
		this.setState({editData: l, showEditModal: true});
	}
	
	removeValue(id,e){
		this.setState({showLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('testmaster/removetest/'+this.state.masterId+'/'+this.state.companyId+'/'+id+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				var l = this.state.dataList;
				var index = l.findIndex(function(obj){
					return (obj.id==id);
				});
				l.splice(index,1);
				this.setState({dataList:l,dataView:l,  showLoader:false});
				notify.show(res['data'].msg,'success');
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false});	
			}
		});
	}
	
	handleRemoveClick(id,e){
		
		swal({title:'Confirm',text:'Do you want to Delete?',buttons:['No','Yes']}).then((willYes)=>{
			if(willYes) this.removeValue(id,e);
		});
				
	}
	
	 handlePageChange(pageNumber) {
	
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	 }
	 
	  
	render(){
		
		 const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		 const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		 const currentTodos = this.state.dataView.slice(indexOfFirstTodo, indexOfLastTodo);
		 let sno = indexOfFirstTodo + 1;
	
		return(
			<div>
			
				<Helmet>
					<title>{appName} | Test Master</title>
				</Helmet>
				
				<PageTitle title="Test Master" loading={this.state.showLoader} > 
					<div className="text-right">
					{/*<button className="btn btn-primary btn-sm btn-primary_2" onClick={()=>{this.setState({showAddModal:true})}} ><i className="fa fa-plus"></i> 
						Add Group
					</button>*/}
							{Roles.Can('manage','testmaster','canadd') ?
								<button className="btn btn-primary btn-sm" onClick={()=>{this.setState({showAddModal:true})}} >
								<i className="fa fa-plus"></i>  Add Test
							</button> : null }
							
							&nbsp;
							<button className="btn btn-primary btn-sm" onClick={this.loadTestMasters} >
								<i className="fa fa-refresh"></i> 
							</button>
					</div>
				</PageTitle>
				
				<Row style={{ marginBottom: 5 }} >
					<Col md={3} >
						<input type="text" className="form-control input-sm" placeholder="Search by [Code, Name]" onChange={this.handleSearch} />
					</Col>
					<Col md={9} >
						{/*<div className="text-right" >
							{Roles.Can('manage','testmaster','canadd') ?
								<button className="btn btn-primary btn-sm" onClick={()=>{this.setState({showAddModal:true})}} >
								<i className="fa fa-plus"></i>  Add Test
							</button> : null }
							
							&nbsp;
							<button className="btn btn-primary btn-sm" onClick={this.loadTestMasters} >
								<i className="fa fa-refresh"></i> 
							</button>
						</div>*/}
					</Col>
				</Row>
				
				<Row>
					
					<Col md={12} >

						<Table hover responsive className="list-table" >
							<thead>
								<tr>
									<th width="60" >Sl.No</th>
									<th>Test Code</th>
									<th>Test Name</th>
									<th width="70" >Unit</th>
									<th>Under Group</th>
									<th>Range</th>
									<th>Amount (Rs.)</th>
									<th>Status</th>
									<th width="80" >Manage</th>
								</tr>
							</thead>
							<tbody>
							{Object.keys(currentTodos).length>0 ?
								currentTodos.map((item,key)=>{
									return <tr key={key} >
										<td>{sno++}</td>
										<td>{item.testcode}</td>
										<td>{item.testname}</td>
										<td>{item.testunit}</td>
										<td>{item.groupname}</td>
										<td>{item.referencerange}</td>
										<td align="right" >&#8377; {item.price}</td>
										<td align="center" >{Sanitize.getStatus(item.teststatus)}</td>
										<td align="center" >
										{Roles.Can('manage','testmaster','canedit') ?
											<button className="btn btn-warning btn-xs" onClick={this.handleEdit.bind(this,item.id)} >
												<i className="fa fa-edit"></i>
											</button> : null }
											&emsp;
										{Roles.Can('manage','testmaster','candelete') ?
											<button className="btn btn-danger btn-xs" onClick={this.handleRemoveClick.bind(this,item.id)} >
												<i className="fa fa-remove"></i>
											</button> : null }
										</td>
									</tr>;
								})
							: <tr>
								<td colSpan="9" align="center" >
									<br />
									No data found..!
								</td>
							</tr>
							}
							</tbody>
						</Table>
					</Col>
				</Row>
				
				<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e)=>{this.setState({activePage:1,currentPage:Number(1), todosPerPage: e.target.value})}} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						 <Pagination
						  activePage={this.state.activePage}
						  itemsCountPerPage={this.state.todosPerPage}
						  totalItemsCount={(this.state.dataView).length}
						  pageRangeDisplayed={7}
						  onChange={(pN)=>{this.setState({activePage:pN, currentPage: Number(pN)})}}
						/>
					</Col>
				</Row>
				
				<Modal size="lg" show={this.state.showAddModal} onHide={()=>{this.setState({showAddModal:false})}} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Add Test</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Add afterFinish={this.loadTestMasters} />
					</Modal.Body>
				</Modal>
				
				<Modal size="lg" show={this.state.showEditModal} onHide={()=>{this.setState({showEditModal:false})}} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Edit Test</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Edit editData={this.state.editData} afterFinish={this.loadTestMasters} />
					</Modal.Body>
				</Modal>
				
			</div>
		);
	}
	
}
export default TestMaster;